import VueCookies from "vue-cookies";
import { loginUser, listLogin } from "@/api/user";

//토큰에 관련된 항목만 처리하는 스토어
const userStore = {
    namespaced: true,
    state: {
        bizNo: VueCookies.get("bizNo") || "",
        ndbTkn: VueCookies.get("ndbTkn") || "",
    },
    getters: {
        isLogin(state) {
            return state.ndbTkn !== undefined && state.ndbTkn !== "";
        },
        bizNo(state) {
            return state.bizNo;
        },
        ndbTkn(state) {
            return state.ndbTkn;
        },
    },
    mutations: {
        SET_NDB_TKN(state, ndbTkn) {
            state.ndbTkn = ndbTkn; // ndbTkn 상태 업데이트
        },
        SET_BIZ_NO(state, bizNo) {
            state.bizNo = bizNo;
        },
        CLEAR_ALL(state) {
            state.bizNo = "";
            state.ndbTkn = "";
        },
    },
    actions: {
        SAVE_BIZ_NO({ commit }, bizNo) {
            VueCookies.set("bizNo", bizNo);
        },
        async LOGIN({ commit }, loginRequest) {
            const { data } = await loginUser(loginRequest);
            commit('SET_BIZ_NO', data.data.id); // 상태 업데이트 추가
            commit('SET_NDB_TKN', data.data.ndbTkn); // 상태 업데이트 추가, 쿠키값만 변경하면 vuex가 상태 변화를 감지하지 못함
            VueCookies.set("bizNo", data.data.id);
            VueCookies.set("ndbTkn", data.data.ndbTkn);
        },
        async AGENT_LOGIN({ commit }, loginRequest) {
            const { data } = await loginUser(loginRequest);
            commit('SET_BIZ_NO', data.data.id); // 상태 업데이트 추가
            commit('SET_NDB_TKN', data.data.ndbTkn); // 상태 업데이트 추가
            VueCookies.set("bizNo", data.data.id);
            VueCookies.set("ndbTkn", data.data.ndbTkn);
        },
        async LIST_LOGIN({ commit }, encBizNo) {
            const { data } = await listLogin(encBizNo);
            commit('SET_BIZ_NO', data.data.id); // 상태 업데이트 추가
            commit('SET_NDB_TKN', data.data.ndbTkn); // 상태 업데이트 추가
            VueCookies.set("bizNo", data.data.id);
            VueCookies.set("ndbTkn", data.data.ndbTkn);
        },
        LOGOUT({ commit }) {
            commit("CLEAR_ALL");
            VueCookies.remove("bizNo");
            VueCookies.remove("ndbTkn");
        },
        REFRESH_USER({ commit }, data) {
            commit("SET_NDB_TKN", data.data.ndbTkn);
            VueCookies.set("ndbTkn", data.data.ndbTkn);
        }
    },
};

export default userStore; 